import { type Location, addDays, formatHourOf, formatWeekdayNumber, relativeDayLabel, todayIn } from '@lindeza/core';
import { useFreeSlots, useProfessional } from '@lindeza/core/hooks';
import { useState } from 'react';
import { Empty, Sheet } from '../../components/ui';

/** Escolher novo dia e horário (só os livres, mesma regra do link). */
export function RescheduleSheet({
  title,
  durationMin,
  location,
  ignoreId,
  onPick,
  onClose,
}: {
  title: string;
  durationMin: number;
  location: Location;
  ignoreId?: string;
  onPick: (start: string) => void;
  onClose: () => void;
}) {
  const prof = useProfessional();
  const tz = prof?.timezone ?? 'America/Sao_Paulo';
  const today = todayIn(tz);
  const [date, setDate] = useState(today);
  const days = Array.from({ length: 21 }, (_, i) => addDays(today, i));
  const slots = useFreeSlots({ durationMin, location, from: date, to: date, ...(ignoreId ? { ignoreAppointmentId: ignoreId } : {}) });
  const ofDay = slots?.find((d) => d.date === date)?.slots ?? [];
  return (
    <Sheet title={title} sub={relativeDayLabel(date, today)} onClose={onClose}>
      <div className="ag-days ag-days--sheet">
        {days.map((d) => {
          const { weekday, day } = formatWeekdayNumber(d);
          return (
            <button key={d} className={d === today ? 'today' : undefined} aria-pressed={d === date} onClick={() => setDate(d)}>
              <span className="wd">{d === today ? 'hoje' : weekday}</span>
              <span className="d">{day}</span>
            </button>
          );
        })}
      </div>
      {slots && ofDay.length === 0 ? (
        <Empty>Sem horário livre neste dia. Escolha outro dia.</Empty>
      ) : (
        <div className="at-hours">
          {ofDay.map((s) => (
            <button key={s.start} className="chip" onClick={() => onPick(s.start)}>
              {formatHourOf(s.start, tz)}
            </button>
          ))}
        </div>
      )}
    </Sheet>
  );
}
